import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation } from "react-router";
import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

const AdminNav = (props) => {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <div id="kt_header_menu" data-menu-vertical="1">
      <ul className="list-unstyled flex-column " role="tablist">
        <li
          className={`nav-item mb-3 menu-item ${getMenuItemActive(
            "/dashboard"
          )}`}
        >
          <NavLink
            className="menu-link nav-link btn btn-icon btn-clean btn-lg"
            to="/dashboard"
            data-toggle="tab"
            id={`#${props.tabs.tabId1}`}
            role="tab"
            onClick={() => props.handleTabChange(props.tabs.tabId1)}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="latest-project">
                  <FormattedMessage id="ADMIN_DASHBOARD" />
                </Tooltip>
              }
            >
              <div>
                <span className="svg-icon svg-icon-lg">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
                </span>
                <span className="menu-text d-none">
                  <FormattedMessage id="ADMIN_DASHBOARD" />
                </span>
              </div>
            </OverlayTrigger>
          </NavLink>
        </li>

        <li
          className={`nav-item mb-3 menu-item ${getMenuItemActive(
            "/informant-member/list-sign-policy"
          )}`}
        >
          <a
            href="#"
            className={`menu-link nav-link btn btn-icon btn-clean btn-lg ${props.activeTab ===
              props.tabs.tabId2 && "active"}`}
            data-toggle="tab"
            id={`#${props.tabs.tabId2}`}
            role="tab"
            onClick={(e) => {
              props.handleTabChange(props.tabs.tabId2);
              e.preventDefault();
            }}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="latest-project">
                  <FormattedMessage id="ASIDE_ADMIN_NAV_POLICY" />
                </Tooltip>
              }
            >
              <span className="svg-icon svg-icon-lg menu-text">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Menu.svg")} />
              </span>
            </OverlayTrigger>
          </a>
        </li>

        <li
          className={`nav-item mb-3 menu-item ${getMenuItemActive(
            "/admin/list-policy"
          )}`}
        >
          <NavLink
            className="menu-link nav-link btn btn-icon btn-clean btn-lg"
            to="/admin/list-informant-member"
            data-toggle="tab"
            id={`#${props.tabs.tabId3}`}
            role="tab"
            onClick={() => props.handleTabChange(props.tabs.tabId3)}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="latest-project">
                  <FormattedMessage id="ASIDE_ADMIN_NAV_INFORMANT" />
                </Tooltip>
              }
            >
              <div>
                <span className="svg-icon svg-icon-lg">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Group.svg"
                    )}
                  />
                </span>
                <span className="menu-text d-none">
                  <FormattedMessage id="ASIDE_ADMIN_NAV_INFORMANT" />
                </span>
              </div>
            </OverlayTrigger>
          </NavLink>
        </li>

        <li
          className={`nav-item mb-3 menu-item ${getMenuItemActive(
            "/admin/list-communication"
          )}`}
          data-toggle="tooltip"
          data-placement="rigth"
          data-container="body"
          data-boundary="window"
          title="Latest Project"
          aria-haspopup="true"
        >
          <NavLink
            className="menu-link nav-link btn btn-icon btn-clean btn-lg"
            to="/admin/list-communication"
            data-toggle="tab"
            id={`#${props.tabs.tabId4}`}
            role="tab"
            onClick={() => props.handleTabChange(props.tabs.tabId4)}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="latest-project">
                  <FormattedMessage id="ADMIN_COMMUNICATION_TITLE" />
                </Tooltip>
              }
            >
              <div>
                <span className="svg-icon svg-icon-lg">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/File-plus.svg"
                    )}
                  />
                </span>
                <span className="menu-text d-none">
                  <FormattedMessage id="ADMIN_COMMUNICATION_TITLE" />
                </span>
              </div>
            </OverlayTrigger>
          </NavLink>
        </li>

        <li
          className={`menu-item d-none ${getMenuItemActive(
            "/user-profile",
            false
          )}`}
        >
          <NavLink className="menu-link" to="/user-profile">
            <span className="menu-text">
              <FormattedMessage id="USER.PROFILE.TITLE" />
            </span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default AdminNav;
